/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionRowSchema } from './collection-row-schema';
import { collectionSourceSchema } from './collection-source';

export { collectionRowSchema, type ICollectionRow } from './collection-row-schema';
export { collectionSourceSchema, type ICollectionSource } from './collection-source';
export { collectionStatusSchema, type ICollectionStatus } from './collection-status';
export { collectionTypeSchema, type ICollectionType } from './collection-type';

export const collectionSchema = collectionRowSchema.extend({
  source: collectionSourceSchema.nullable(),
  posterUrl: z.string().nullable().optional(),
  backdropUrl: z.string().nullable().optional(),
  thumbnailUrl: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
  trailerUrl: z.string().nullable().optional(),
  parentTitle: z.string().nullable().optional(),
});

export type ICollection = z.infer<typeof collectionSchema>;

export const challengeStatusCountsSchema = z.object({
  seed: z.number(),
  sanitized: z.number(),
  prefilled: z.number(),
  draft: z.number(),
  populated: z.number(),
  reset: z.number(),
  approved: z.number(),
  flagged: z.number(),
  rejected: z.number(),
  disabled: z.number(),
  clipless: z.number().default(0),
});

export type IChallengeStatusCounts = z.infer<typeof challengeStatusCountsSchema>;

export const collectionWithCountsSchema = collectionSchema.extend({
  childrenCount: z.number(),
  challengesCount: z.number(),
  publishedCount: z.number().optional(),
  unpublishedCount: z.number().optional(),
  hasSubtitle: z.boolean(),
  statusCounts: challengeStatusCountsSchema.optional(),
});

export type ICollectionWithCounts = z.infer<typeof collectionWithCountsSchema>;
